import React from 'react';
import { Button, Flex } from '@chakra-ui/react';

import { HubCounterDiagnostics } from './hubCounterState';

type HubCounterLifecycleCtasProps = {
  diagnostics: HubCounterDiagnostics;
  onMoveToPending: () => void;
  onMoveToWaitlist: () => void;
  onReject: () => void;
  onConfirm: () => void;
  statusLoading?: boolean;
};

/** Lifecycle CTAs shared by Amazon Support header and Developer Utilities. */
export const HubCounterLifecycleCtas = ({
  diagnostics,
  onMoveToPending,
  onMoveToWaitlist,
  onReject,
  onConfirm,
  statusLoading = false,
}: HubCounterLifecycleCtasProps) => {
  const hasActions =
    diagnostics.canMoveToPending || diagnostics.canMoveToWaitlist || diagnostics.canRejectAmazon || diagnostics.canConfirmAmazon;

  if (!hasActions) return null;

  return (
    <Flex alignItems="center" gap="2" flexWrap="wrap">
      {diagnostics.canMoveToPending ? (
        <Button size="sm" colorScheme="brand" onClick={onMoveToPending} isLoading={statusLoading}>
          Auf PENDING setzen
        </Button>
      ) : null}
      {diagnostics.canMoveToWaitlist ? (
        <Button size="sm" colorScheme="brand" onClick={onMoveToWaitlist} isLoading={statusLoading}>
          Auf WAITLIST setzen
        </Button>
      ) : null}
      {diagnostics.canRejectAmazon ? (
        <Button size="sm" colorScheme="red" variant="outline" onClick={onReject}>
          Hub Counter ablehnen
        </Button>
      ) : null}
      {diagnostics.canConfirmAmazon ? (
        <Button size="sm" colorScheme="brand" onClick={onConfirm}>
          Nur Amazon aktivieren
        </Button>
      ) : null}
    </Flex>
  );
};
